import { Dialog, Transition } from '@headlessui/react';
import {
  IconAlertTriangle,
  IconReceipt,
  IconCalendar,
  IconBuildingStore,
  IconUser,
  IconScale,
  IconDiamond,
  IconCash,
  IconNotes
} from '@tabler/icons-react';
import { Fragment, useState, useEffect } from 'react';
import { imageBaseUrl } from '../../config/http';
import { toast } from 'react-toastify';

export default function ConfirmationDeletePembelian({
  isDelete,
  deletePembelian,
  pembelianDelete,
  isOpenModalDelete,
  closeModalDelete,
}) {
  const [alasan, setAlasan] = useState('Salah input data');
  const [keterangan, setKeterangan] = useState('');

  useEffect(() => {
    if (isOpenModalDelete) {
      setAlasan('Salah input data');
      setKeterangan('');
    }
  }, [isOpenModalDelete]);

  function numberWithCommas(x) {
    if (x === null || x === undefined || x === '') return '0';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (alasan === 'Lainnya' && !keterangan.trim()) {
      toast.warning('Silakan isi keterangan jika memilih alasan Lainnya');
      return;
    }
    deletePembelian(alasan, keterangan.trim());
  };

  const fotoBarang = pembelianDelete?.gambar?.[0]?.asli || pembelianDelete?.gambar?.[0]?.thumbnail;

  return (
    <Transition appear show={isOpenModalDelete} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={isDelete ? () => {} : closeModalDelete}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-slate-900/60 dark:bg-slate-950/80 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white dark:bg-[#0f172a] p-6 text-left align-middle shadow-2xl transition-all border border-slate-200 dark:border-slate-800">
                {/* Header Modal */}
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-red-50 dark:bg-red-950/40 border-2 border-red-500/80 text-red-600 dark:text-red-400 flex items-center justify-center shrink-0 shadow-sm">
                    <IconAlertTriangle size={26} stroke={2.2} />
                  </div>
                  <div className="flex-1">
                    <Dialog.Title as="h3" className="text-lg font-bold text-slate-800 dark:text-slate-100">
                      Konfirmasi Hapus Pembelian
                    </Dialog.Title>
                    <p className="text-sm text-slate-500 dark:text-slate-400 mt-1">
                      Apakah Anda yakin ingin menghapus transaksi pembelian dengan Kode{' '}
                      <span className="font-mono font-bold text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-950/40 px-1.5 py-0.5 rounded border border-red-200 dark:border-red-900/40">
                        {pembelianDelete?.kode_trx}
                      </span>?
                    </p>
                  </div>
                </div>

                {/* Rangkuman Transaksi Pembelian */}
                <div className="mt-4 bg-slate-50 dark:bg-slate-900/60 rounded-xl p-3.5 border border-slate-200/80 dark:border-slate-800 text-xs">
                  <div className="flex items-center justify-between border-b border-slate-200/80 dark:border-slate-700/80 pb-2 mb-2.5">
                    <div className="flex items-center gap-1.5 font-bold text-slate-700 dark:text-slate-200">
                      <span>Rangkuman Transaksi</span>
                    </div>
                    <span className="text-[11px] font-semibold text-slate-400 dark:text-slate-500 flex items-center gap-1">
                      <IconCalendar size={13} /> {pembelianDelete?.created_at || '-'}
                    </span>
                  </div>

                  <div className="flex flex-col sm:flex-row gap-3">
                    {/* Thumbnail Foto jika ada */}
                    {fotoBarang && (
                      <div className="shrink-0 flex sm:flex-col items-center justify-center">
                        <img
                          src={`${imageBaseUrl}${fotoBarang}`}
                          alt="Foto Barang"
                          className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg border border-slate-200 dark:border-slate-700 shadow-xs"
                        />
                      </div>
                    )}

                    {/* Rincian Barang & Transaksi */}
                    <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1.5 text-slate-600 dark:text-slate-300">
                      <div>
                        <span className="text-[10px] text-slate-400 dark:text-slate-500 font-semibold uppercase tracking-wider block">
                          Toko / Cabang
                        </span>
                        <span className="font-semibold text-slate-800 dark:text-slate-200 flex items-center gap-1">
                          {pembelianDelete?.user?.cabang?.nama_cabang || pembelianDelete?.cabang?.nama_cabang || '-'}
                        </span>
                      </div>

                      <div>
                        <span className="text-[10px] text-slate-400 dark:text-slate-500 font-semibold uppercase tracking-wider block">
                          Petugas Kasir
                        </span>
                        <span className="font-semibold text-slate-800 dark:text-slate-200 flex items-center gap-1">
                          {pembelianDelete?.user?.name || '-'}
                        </span>
                      </div>

                      <div>
                        <span className="text-[10px] text-slate-400 dark:text-slate-500 font-semibold uppercase tracking-wider block">
                          Barang
                        </span>
                        <span className="font-bold text-slate-800 dark:text-slate-100 flex items-center gap-1">
                          {pembelianDelete?.jenis_kategori?.nama_jenis || 'Perhiasan Emas'}
                        </span>
                      </div>

                      <div>
                        <span className="text-[10px] text-slate-400 dark:text-slate-500 font-semibold uppercase tracking-wider block">
                          Berat & Kadar
                        </span>
                        <span className="font-semibold text-slate-800 dark:text-slate-200 flex items-center gap-1">
                          {pembelianDelete?.berat} gr
                          <span className="font-medium text-amber-600 dark:text-amber-400 text-[11px]">
                            ({pembelianDelete?.karat} K)
                          </span>
                        </span>
                      </div>

                      {pembelianDelete?.keterangan && (
                        <div className="col-span-1 sm:col-span-2 pt-1 border-t border-slate-100 dark:border-slate-800 text-[11px] text-slate-500 dark:text-slate-400 flex items-start gap-1">
                          <span>Ket: <em className="italic">{pembelianDelete?.keterangan}</em></span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Nominal Total Pembelian */}
                  <div className="mt-2 pt-2 border-t border-slate-200/80 dark:border-slate-700/80 flex items-center justify-between">
                    <span className="font-semibold text-slate-500 dark:text-slate-400 flex items-center gap-1">
                      Total Pembelian:
                    </span>
                    <span className="font-bold text-base text-red-600 dark:text-red-400">
                      Rp {numberWithCommas(pembelianDelete?.harga_beli ?? pembelianDelete?.total_harga ?? 0)}
                    </span>
                  </div>
                </div>

                {/* Info Catatan Return Pembelian / Saldo Kas */}
                <div className="mt-3 p-3 rounded-xl bg-amber-50 dark:bg-amber-900/30 border border-amber-200/80 dark:border-amber-700/50 text-xs text-amber-800 dark:text-amber-200 flex items-start gap-2.5">
                  <IconAlertTriangle size={17} className="shrink-0 mt-0.5 text-amber-600 dark:text-amber-400" />
                  <span className="leading-relaxed">
                    Data transaksi pembelian tidak dihapus permanen, melainkan statusnya diubah menjadi <strong className="text-amber-900 dark:text-amber-400">Return Pembelian</strong>. Saldo kas toko akan otomatis ditambah dan dicatat ke History Saldo dengan status/tipe <strong>Return Pembelian</strong>.
                  </span>
                </div>

                {/* Form Input Alasan & Keterangan */}
                <form onSubmit={handleSubmit} className="mt-4 space-y-3">
                  {/* Select Alasan */}
                  <div>
                    <label className="block text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider mb-1">
                      Alasan Penghapusan <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={alasan}
                      onChange={(e) => setAlasan(e.target.value)}
                      disabled={isDelete}
                      className="w-full border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 rounded-xl p-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500/40 focus:border-red-500 cursor-pointer disabled:opacity-50"
                    >
                      <option value="Salah input data">Salah input data</option>
                      <option value="Salah harga beli">Salah harga beli</option>
                      <option value="Salah berat / kadar karat">Salah berat / kadar karat</option>
                      <option value="Duplikat transaksi">Duplikat transaksi</option>
                      <option value="Transaksi dibatalkan / salah faktur">Transaksi dibatalkan / salah faktur</option>
                      <option value="Lainnya">Lainnya</option>
                    </select>
                  </div>

                  {/* Textarea Keterangan */}
                  <div>
                    <label className="block text-xs font-bold text-slate-700 dark:text-slate-300 uppercase tracking-wider mb-1">
                      Keterangan Tambahan{' '}
                      {alasan === 'Lainnya' ? (
                        <span className="text-red-500">*</span>
                      ) : (
                        <span className="text-slate-400 font-normal lowercase">(opsional)</span>
                      )}
                    </label>
                    <textarea
                      rows={2}
                      value={keterangan}
                      onChange={(e) => setKeterangan(e.target.value)}
                      disabled={isDelete}
                      placeholder={
                        alasan === 'Lainnya'
                          ? 'Wajib menuliskan alasan penghapusan...'
                          : 'Tuliskan catatan detail jika diperlukan...'
                      }
                      className="w-full border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 rounded-xl p-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-red-500/40 focus:border-red-500 resize-none disabled:opacity-50"
                    />
                  </div>

                  {/* Action Buttons */}
                  <div className="pt-3 border-t border-slate-100 dark:border-slate-800 flex items-center justify-end gap-2.5">
                    <button
                      type="button"
                      onClick={closeModalDelete}
                      disabled={isDelete}
                      className="px-4 py-2 rounded-xl text-sm font-semibold text-slate-600 dark:text-slate-300 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 active:bg-slate-300 transition-colors disabled:opacity-50"
                    >
                      Batal
                    </button>
                    <button
                      type="submit"
                      disabled={isDelete}
                      className="px-5 py-2 rounded-xl text-sm font-semibold text-white bg-red-600 hover:bg-red-700 active:bg-red-800 transition-colors flex items-center gap-2 shadow-sm shadow-red-500/20 disabled:opacity-60"
                    >
                      {isDelete ? (
                        <>
                          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                          <span>Memproses...</span>
                        </>
                      ) : (
                        <span>Hapus Pembelian</span>
                      )}
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
